module.exports = __webpack_public_path__ + "img/ltkcyberweek-1x.ac20365.jpg";